import { Box, Button, IconButton } from "@mui/material";
import React from "react";
import ReactPlayer from "react-player";

const VideoPreviewComponent = ({ videoFile }) => {
  // "";
  return (
    <Box className="video-wrapper">
      {/* <video
        className=""
        controls
        muted
        src={videoFile.video}
      /> */}
      <ReactPlayer
        url={videoFile.video}
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
        height={"100%"}
        width={"100%"}
        // playing={play}
        controls={true}
      />
    </Box>
  );
};

export default VideoPreviewComponent;
